// src/com/user_info/InformForgotPassword.js
import { Link, Paper } from "@mui/material";


export default function InformForgotPassword() {
    return(
        <Paper style={{backgroundColor:"#cef",padding:10}} >
            <div>암호를 잊은 경우 아래 이메일로 아이디, 이름, 소속, 변경할 암호를 발송</div>
            <div>남지원 : <Link to='#'
                            onClick={(e) => {
                                window.location = "mailto:njw3064@homeplus.co.kr";
                                e.preventDefault();
                            }} >njw3064@homeplus.co.kr</Link>
            </div>
            <div>한대선 : <Link to='#'
                            onClick={(e) => {
                                window.location = "mailto:hds@homeplus.co.kr";
                                e.preventDefault();
                            }} >hds@homeplus.co.kr</Link></div>
        </Paper>
    );
}